import React from "react";
import Portal from "../Portal/Portal";
import "./LessonNotAvailableModal.css";

interface LessonNotAvailableModalProps {
  show: boolean;
  message: string;
}

const LessonNotAvailableModal: React.FC<LessonNotAvailableModalProps> = ({ show, message }) => {
  if (!show) return null;

  return (
    <Portal>
      <div className="lesson-not-available-overlay">
        <div className="lesson-not-available-modal">
          <h2>Lesson Not Available</h2>
          <p>{message}</p>
        </div>
      </div>
    </Portal>
  );
};

export default LessonNotAvailableModal;
